import { validateEnumTranslations } from '../../safety_checks';
import { BookingCustomFieldType } from '../booking_custom_field';

export const BOOKING_CUSTOM_FIELD_TYPE_TRANSLATE_KEY = 'BOOKING_CUSTOM_FIELD_TYPE_';

export const BookingCustomFieldTypeTranslation = {
  'fr-FR': {
    [`${BOOKING_CUSTOM_FIELD_TYPE_TRANSLATE_KEY}${BookingCustomFieldType.TEXT}`]: 'Texte court',
    [`${BOOKING_CUSTOM_FIELD_TYPE_TRANSLATE_KEY}${BookingCustomFieldType.TEXTAREA}`]: 'Texte long',
    [`${BOOKING_CUSTOM_FIELD_TYPE_TRANSLATE_KEY}${BookingCustomFieldType.SELECT}`]: 'Liste déroulante',
    [`${BOOKING_CUSTOM_FIELD_TYPE_TRANSLATE_KEY}${BookingCustomFieldType.NUMBER}`]: 'Nombre',
    [`${BOOKING_CUSTOM_FIELD_TYPE_TRANSLATE_KEY}${BookingCustomFieldType.CHECKBOX}`]: 'Case à cocher',
    [`${BOOKING_CUSTOM_FIELD_TYPE_TRANSLATE_KEY}${BookingCustomFieldType.DATE}`]: 'Date',
  },
};

validateEnumTranslations(
  BookingCustomFieldType,
  BookingCustomFieldTypeTranslation,
  BOOKING_CUSTOM_FIELD_TYPE_TRANSLATE_KEY,
  true,
);
